<template>
  <div class="min-h-screen w-full relative">
    <!-- Full Background Image -->
    <img
      src="@/assets/images/loginpage.png"
      alt="Background"
      class="absolute inset-0 object-cover w-full h-full"
    />

    <div class="absolute inset-0 bg-cyan-900 bg-opacity-60"></div>

    <div class="relative z-10 flex items-center justify-center min-h-screen px-4">
      <div class="bg-white rounded-xl shadow-lg p-8 md:p-12 w-full max-w-md">
        <!-- Logo -->
        <div class="flex justify-center mb-6">
          <img src="@/assets/images/kenscio-logo.png" alt="kenscio-logo" class="w-16" />
        </div>

        <!-- Login Form -->
        <el-form ref="form" :model="loginForm" :rules="loginRules" label-position="top">
          <el-form-item label="Email" prop="username">
            <el-input v-model="loginForm.username" type="email" autocomplete="email" />
          </el-form-item>

          <el-form-item label="Password" prop="password">
            <el-input v-model="loginForm.password" type="password" />
          </el-form-item>
        </el-form>

        <button
          @click="onLoginSubmit"
          class="w-full mt-4 bg-cyan-900 text-white py-2 rounded-md hover:bg-cyan-800 transition duration-200"
        >
          Login
        </button>

          <!-- Forgot Password -->
          <div class="text-sm text-center mt-4 text-gray-600 ml-14">
            <a href="/forgotPassword" class="text-sm text-red-900 mr-20 hover:underline">Forgot Password?</a>
          </div>
  
          <!-- Register Link -->
          <div class="text-sm text-center mt-4 text-gray-600">
            Don't have an account?
            <a href="/registerPage" class="text-blue-900 hover:underline">Register Now</a><br />
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import login from "./login.js";
export default login;
</script>

<style lang="scss" src="./login.scss"></style>